import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./home";
import View from "./workshop";

const Editor = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<View />} />
    </Routes>
  );
};

export default Editor;
